import { render, staticRenderFns } from "./AppBottomSheet.vue?vue&type=template&id=8adddf04&scoped=true"
import script from "./AppBottomSheet.vue?vue&type=script&lang=js"
export * from "./AppBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./AppBottomSheet.vue?vue&type=style&index=0&id=8adddf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adddf04",
  null
  
)

export default component.exports